import React from "react";
import { Button } from "react-bootstrap";
import Icon from "../../../components/Icon";
import SearchHistoryItem from "./SearchHistoryItem";
import { useGetLatestQueries } from "../../../hooks";

interface Props {
  onClick: (params: { item: string }) => void;
  limit?: number;
}

const SearchHistory = (props: Props) => {
  const { onClick, limit } = props;
  const { data: { data: history } = {} } = useGetLatestQueries();

  return (
    <div className="search-history">
      <h5 className="search-history__list-title">
        <Icon name="clock-history" /> Recent Queries
      </h5>
      {!history?.length ? (
        <div>Search history empty.</div>
      ) : (
        <ul className="search-history__list">
          {history?.slice(0, limit || history.length).map((item, index) => (
            <li key={index} className="search-history__list-item">
              <Button
                variant="link"
                onClick={() => onClick({ item })}
                style={{ display: "flex", flexDirection: "column" }}
                className="history-link"
              >
                {" "}
                <SearchHistoryItem
                  history={item}
                  queryClassname={"overflow-ellipsis width-100-pc"}
                />
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchHistory;
